import React, { useEffect, useState } from 'react';
import { alertError } from '../../utils/logger';
import { useHistory } from 'react-router-dom';
import { useSelector, shallowEqual } from 'react-redux';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import { countAdmins } from '../../api/user'

export function DashboardPage() {
	const [data, setData] = useState([]);
    const history = useHistory();
	const user = useSelector((store) => store.authentication?.user, shallowEqual);
	const isAdmin = user && user?.role === "admin";

	useEffect(() => {
		if (isAdmin) {
			async function fetchData() {
				try {
					const admins = await countAdmins()

					setData({
						numAdmins: admins.data
					})
				} catch (err) {
					alertError({ error: err, customMessage: 'Could not get statistics.'})
				}
			}
			fetchData()
		}
	}, [isAdmin]);

	if (!isAdmin) {
		return (
			<>
				<div className='row justify-content-center'>
					<div className='col-12 col-md-8 text-center my-5'>
						<div className='card'>
							<div className='card-body'>
								<h3 className='card-title text-danger'>Acceso Denegado</h3>
								<p className='card-text mt-3'>
									No tienes permisos para acceder al backoffice. Solo los administradores pueden acceder a esta área.
								</p>
								<button 
									className='btn btn-primary mt-3'
									onClick={() => {
										// Cerrar sesión y redirigir al login
										window.location.href = '/logout';
									}}
								>
									Cerrar Sesión
								</button>
							</div>
						</div>
					</div>
				</div>
			</>
		);
	}

	return (
		<>
			<div className='row justify-content-center'>
				<div className='col-12 col-md-4 text-center my-2' role='button' onClick={() => history.push('/admins')}>
					<div className='card'>
						<div className='card-body'>
							<h5 className='card-title'><AssignmentIndIcon/>  Administrators</h5>
							<div className='contentDash'>{data.numAdmins}</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
